// Names mirror the conversation list tabs (Em atendimento / Pendentes / Todas)
export const LIVE_METRICS = {
  assigned: {
    i18nKey: 'ASSIGNED',
    icon: 'i-lucide-headset',
    tone: 'blue',
  },
  pending: {
    i18nKey: 'PENDING',
    icon: 'i-lucide-hourglass',
    tone: 'amber',
  },
  all: {
    i18nKey: 'ALL',
    icon: 'i-lucide-messages-square',
    tone: 'slate',
  },
};

export const TONE_CLASSES = {
  blue: 'bg-n-blue-3 text-n-blue-11',
  amber: 'bg-n-amber-3 text-n-amber-11',
  ruby: 'bg-n-ruby-3 text-n-ruby-11',
  teal: 'bg-n-teal-3 text-n-teal-11',
  slate: 'bg-n-alpha-2 text-n-slate-11',
};

export const buildLiveMetric = (t, key, value) => ({
  key,
  ...LIVE_METRICS[key],
  label: t(`OVERVIEW_REPORTS.LIVE_METRICS.${LIVE_METRICS[key].i18nKey}.LABEL`),
  hint: t(`OVERVIEW_REPORTS.LIVE_METRICS.${LIVE_METRICS[key].i18nKey}.HINT`),
  value: value || 0,
});
